import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Location, CurrencyPipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, ConstantService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RateManagerService } from '../../../rate-manager/rate-manager.service';
import { RateBucketService } from '../../../rate-bucket/rate-bucket.service';
import { RateBucket } from '../../../rate-bucket/rate-bucket';
import { RateOverrideService } from '../../rate-override.service';
import { PercentageValuesNegative, PercentageValuesPositiveAndNegative,PercentageValuesPositive } from '@app/_helpers';
import { RateBucketDetail } from '@app/_components/rate/rate-bucket-detail';

@Component({
    selector: 'app-rate-override-form',
    templateUrl: './rate-override-form.component.html',
    styleUrls: ['./rate-override-form.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RateOverrideFormComponent implements OnInit {
	locationIds: any[];

 constructor(
		private currencyPipe: CurrencyPipe,
		private rateOverrideService: RateOverrideService,
		private rateManagerService: RateManagerService,
		private rateBucketService: RateBucketService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		private constantService: ConstantService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data)
	{
		this.formTitle = data.title,
			this.rateBucketOverride = data.rateBucketOverride,
			this.rateBucketOverrideId = data.rateBucketOverrideId,
			this.formAction = data.formAction,
			this.locationIds = this.constantService.locations;
	}

	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();


	// data
	apiResponse: ApiResponse;
	rateBucketOverrideId: number;
	rateBucketOverride: any;
		rateBucketOverrides: any;
	percentageValuesPositive: any = PercentageValuesPositive;
	percentageValuesNegative: any = PercentageValuesNegative;
	percentageValuesPositiveAndNegative: any = PercentageValuesPositiveAndNegative;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAction: string;
	formLabels = [];
	formReadOnly = false;
	formAlert: string;
	formTitle: string;


	//
	autoTicks = false;
	disabled = false;
	invert = false;
	max = 1;
	min = -1;
	step = .01;
	tickInterval = .01;
	showTicks = true;
	thumbLabel = false;
	value = 0;
	vertical = false;


	rateBucketTypes = [
		{ value: 'RC', name: 'Auto' },
		{ value: 'SP', name: 'Manual' }
	];


	seasonCategories = [
		{ value: 1, name: 'Low' },
		{ value: 2, name: 'Low-Medium' },
		{ value: 3, name: 'Medium' },
		{ value: 4, name: 'Medium-High' },
		{ value: 5, name: 'High' },
	];


	discountAlorithms = [
		{ value: '1', name: 'Straight Line' },
	];




	validationMessages = {
		rateBucketOverrideId: [],
		rateBucketId: [{ type: 'required', message: 'Required' }],
		locationId: [],
		name: [{ type: 'required', message: 'Required' }],
		rateBucketName: [],
		description: [{ type: 'required', message: 'Required' }],
		publicRateNote: [],
		rateBucketType: [{ type: 'required', message: 'Required' }],
		startDate: [{ type: 'required', message: 'Required' }],
		endDate: [{ type: 'required', message: 'Required' }],
		listPrice: [],
		listPriceAdjustmentPercent: [],
		listPriceAdjustmentAmount: [{ type: 'required', message: 'Required' }],
		minimumPriceSetByManager: [],
		minimumPriceSetByOwner: [],
		seasonCategory: [{ type: 'required', message: 'Required' }],
		seasonOccupancy: [{ type: 'required', message: 'Required' }],
		discountMaxPercent: [],
		discountLookForwardDays: [],
		discountHeadlineSpecialsLookForwardDays: [],
		discountHeadlineSpecialsMinNightsToAnalyze: [],
		discountIntervalDays: [],
		discountCombinationDays: [],
		discountAlorithm: [],
		minStayExpected: [],
		maxStayExpected: [],
		avgStayBySeason: [],
		shortTermGapMultiplier: [],
		shortTermGapPenaltyPercent: [],
		shortTermGapMinNightsReqRev: [],
		longTermGapMultiplier: [],
		longTermGapPenaltyPercent: [],
		longTermGapEmptyMultiplier: [],
		longTermGapEmptyPenaltyPercent: [],
		connectingFrontOrBackMultiplier: [],
		connectingFrontAndBackMultiplier: [],
		lengthOfStayDiscountFactorOffset: [],
		whereAddressIsland: [],
		whereAddressRegion: [],
		whereAddressDistrictName: [],
		whereAddressCity: [],
		whereAddressBuildingName: [],

	};

	ngOnInit()
	{

		this.formBuild();
		this.loadRateBuckets();

		// if we were passed the whole rateBucketOverride object
		if (this.rateBucketOverride)
		{
			this.rateBucketOverrideId = this.rateBucketOverride.rateBucketOverrideId;
			this.form1.patchValue(this.rateBucketOverride);
		}

		// if we were passed just the rateBucketOverrideId (ie from Advertised Rates form), get the object
		else if (this.rateBucketOverrideId)
		{
			this.findRateBucketDetailById(this.rateBucketOverrideId);
		}
	}


	onFormDelete()
	{
		console.log('onFormDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.rateBucketOverrideId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () =>
			{
				this.formDelete()
			},
			reject: () =>
			{
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}

			this.formLoading = true;
			this.rateOverrideService.add(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('rateBucketOverride-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rateBucketOverride = res.data.rateBucketOverride;
						this.doAdd.emit(this.rateBucketOverride);

					},
					err =>
					{
						console.log('rateBucketOverride-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}


	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			if (this.form1.invalid)
			{
				return;
			}
			this.formLoading = true;

			this.rateOverrideService.update(this.form1.value)
				.subscribe(
					res =>
					{
						console.log('formUpdate: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.rateBucketOverride = res.data.rateBucketOverride;
						this.doUpdate.emit(this.rateBucketOverride);
					},
					err =>
					{
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete()
	{
		try
		{

			this.rateOverrideService.delete(this.rateBucketOverride.rateBucketOverrideId)
				.subscribe(
					res =>
					{
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.rateBucketOverride);
					},
					err =>
					{
						console.log('rateBucketOverride-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	loadRateBuckets()
	{
		try
		{
			this.rateBucketService.findAll()
				.subscribe(
					res =>
					{
						this.rateBucketOverrides = res.data.rateBuckets;
					},
					err =>
					{
						console.log('loadRateBuckets-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	findRateBucketDetailById(rateBucketOverrideId)
	{
		try
		{
			this.rateOverrideService.findById(rateBucketOverrideId)
				.subscribe(
					res =>
					{
						this.rateBucketOverride = res.data.rateBucketOverride;
						this.form1.patchValue(this.rateBucketOverride);
					},
					err =>
					{
						console.log('findRateBucketDetailById FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.form1 = this.formBuilder.group({
			rateBucketOverrideId: [this.rateBucketOverrideId],
			createDate: [],
			lastUpdate: [],
			name: ['', Validators.required],
			rateBucketName: [],
			description: [],
			publicRateNote: [],
			rateBucketType: ['OR'],
			startDate: ['', Validators.required],
			endDate: ['', Validators.required],
			listPrice: ['', Validators.required],
			listPriceAdjustmentPercent: [],
			listPriceAdjustmentAmount: [],
			minimumPriceSetByManager: [],
			minimumPriceSetByOwner: [],
			seasonCategory: [3],
			seasonOccupancy: [.75],
			discountMaxPercent: [.50],
			discountLookForwardDays: [90],
			discountHeadlineSpecialsLookForwardDays: [30],
			discountHeadlineSpecialsMinNightsToAnalyze: [4],
			discountIntervalDays: [7],
			discountCombinationDays: [7],
			discountAlorithm: [1],
			minStayExpected: [2],
			maxStayExpected: [8],
			avgStayBySeason: [4],
			shortTermGapMultiplier: [.65],
			shortTermGapPenaltyPercent: [1.00],
			shortTermGapMinNightsReqRev: [2.00],
			longTermGapMultiplier: [.75],
			longTermGapPenaltyPercent: [1.00],
			longTermGapEmptyMultiplier: [.4],
			longTermGapEmptyPenaltyPercent: [1.00],
			connectingFrontOrBackMultiplier: [-.04],
			connectingFrontAndBackMultiplier: [-.08],
			lengthOfStayDiscountFactorOffset: [-.02],
			whereLocationId: [],
			whereDevelopmentId: [],
			whereShortTermRentalId: [],
			whereSeasonCategory: [],
			whereRateBucketId: [],
			whereStartDate: [],
			whereEndDate: [],
			whereAddressIsland: [],
			whereAddressRegion: [],
			whereAddressDistrictName: [],
			whereAddressCity: [],
			whereAddressBuildingName: [],
			whereNumBedroom0: [],
			whereNumBedroom1: [],
			whereNumBedroom2: [],
			whereNumBedroom3: [],
			whereNumBedroom4: [],
			whereNumBedroom5: [],
			whereNumBedroom6: [],
			whereNumBedroom7: [],
			whereNumBedroom8: [],
			whereNumBedroom9: [],
			whereNumBedroom10: [],
			whereNumBedroom11: [],
			whereNumBedroom12: []
		});
	}

	getSliderTickInterval(): number | 'auto'
	{
		if (this.showTicks)
		{
			return this.autoTicks ? 'auto' : this.tickInterval;
		}

		return 0;
	}
}
